import { useState, useEffect, useCallback } from "react";
import { GLOBAL_STATS_QUERY } from "../api/queries";
import { unifarmFactory } from "../utils/contract";
import { apiRequest } from "../api/apiService";

export const useGlobalStats = ({
    skip = 0,
    first = 10,
    orderBy = "TVL",
    orderDirection = "desc",
} = {}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchGlobalStats = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await apiRequest({
                url: unifarmFactory.rootTokens,
                method: "POST",
                data: {
                    query: GLOBAL_STATS_QUERY,
                    variables: {
                        skip,
                        first,
                        orderBy,
                        orderDirection,
                        where: {}, // 🔹 Empty filter = fetch all
                    },
                },
                auth: false,
            });

            setData(response?.data?.globalStats ?? []);
        } catch (err) {
            console.error("Error fetching global stats:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [skip, first, orderBy, orderDirection]);

    useEffect(() => {
        fetchGlobalStats();
    }, [fetchGlobalStats]);

    return { data, loading, error, refetch: fetchGlobalStats };
};
